/* eslint-disable no-console */
import initializeTranslations from './translationsService';
import initializeDatadog from './datadogInitializer';

const datadogHandler = async () => {
  try {
    return await initializeDatadog();
  } catch (err) {
    if (err instanceof Error) throw new Error(`Datadog: ${err.message}`);
    throw new Error(`Datadog: ${JSON.stringify(err)}`);
  }
};

const translationHandler = async () => {
  try {
    return await initializeTranslations();
  } catch (err) {
    if (err instanceof Error) throw new Error(`Translations: ${err.message}`);
    throw new Error(`Translations: ${JSON.stringify(err)}`);
  }
};

const initalization = async (): Promise<void> => {
  try {
    await translationHandler();
    await datadogHandler();

    return;
  } catch (err) {
    if (err instanceof Error) {
      console.error(`Was not able to initialize service - ${err.message}`);
      return;
    }
    console.error(
      `Was not able to initialize service - ${JSON.stringify(err)}`,
    );
  }
};

export default initalization;
